<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="column is-4 is-offset-4">
          <!--<h3 class="title has-text-grey is-4">Login</h3>-->
          <!--<p class="subtitle has-text-grey">Please login to proceed.</p>-->
          <div class="box">
            <h3 class="subtitle is-3">SX-Score Console</h3>
            <!--<figure class="avatar">-->
            <!--<img src="https://placehold.it/128x128">-->
            <!--</figure>-->

            <b-message v-if="isIdle" title="セッションの有効期限が切れました" type="is-warning">再度ログインをしてください</b-message>
            <div class="field">
              <div class="control">
                <input class="input is-large" type="text" placeholder="User ID" autofocus="" v-model="userName">
              </div>
            </div>

            <div class="field">
              <div class="control">
                <input class="input is-large" type="password" placeholder="Access Key ID" v-model="accessKeyID">
              </div>
            </div>
            <button class="button is-block is-primary is-large is-fullwidth"
                    :class="isLoading ? 'is-loading' : ''"
                    @click="login">Login
            </button>
          </div>
          <p class="has-text-grey">
            <!--<a href="../">Sign Up</a> &nbsp;·&nbsp;-->
            <!--<a href="../">Forgot Password</a>-->
            <!--<a href="../">Need Help?</a>-->
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {authRequest} from '../modules/request/auth'

export default {
  name: 'Login',
  data () {
    return {
      userName: '',
      accessKeyID: '',
      isLoading: false
    }
  },
  computed: {
    isIdle () {
      return this.$route.query.isIdle
    }
  },
  methods: {
    login () {
      authRequest(this)
    }
  }
}
</script>

<style scoped>
  .box {
    background: #ECF0F3;
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue